import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ComuneModel, DatiPersonaFisicaModel, IndirizzoModel, LocalitaModel, NazioneModel, VerificaPfResponseDTO} from '../../models/estremi-persona-fisica.model';
import {getErrorMessage} from '../../utils/validators-messages.utils';
import {ibanValidator} from "ngx-iban";
import {BonificoExtraSepaModel} from '../../models/bonifico-extra-sepa.model';
import {ModalitaPagamentoService} from '../../services/modalita-pagamento.service';
import {take} from 'rxjs/operators';

@Component({
	selector: 'lib-bonifico-extra-sepa',
	templateUrl: './bonifico-extra-sepa.component.html',
	styleUrls: ['./bonifico-extra-sepa.component.scss'],
})
export class BonificoExtraSepaComponent implements OnInit {

	@Input()
	viewDelegato: boolean;

	@Input()
	bonificoExtraSepa: BonificoExtraSepaModel;

	@Input()
	isPersonaFisicaExtraSepaValid: boolean;

	@Input()
	nazioni: NazioneModel[];

	@Input()
	province: LocalitaModel[];

	@Input()
	comuni: ComuneModel[];

	@Input()
	capOptions: string[];

	@Input()
	extraSepaFormPath: string;

	@Input()
	estremiPFExtraSepaFormPath: string;

	@Input()
	viewSessoPF: boolean = false;

	@Input()
	validateAndGetResidenza: VerificaPfResponseDTO;

	@Input()
	indirizzoVagliaFormPath: string;

	@Output()
	validateExtraSepaPersonaFisicaEmitter = new EventEmitter<void>();

	@Output()
	resetEstremiPersonaFisicaExtraSepaFormEmitter = new EventEmitter<void>();

	@Output()
	bonificoExtraSepaReady = new EventEmitter<{ bonifico: BonificoExtraSepaModel, isValid: boolean }>();

	@Output()
	personaFisicaEmitter = new EventEmitter<{ persona: DatiPersonaFisicaModel, isValid: boolean }>();

	@Output()
	setComuni = new EventEmitter<ComuneModel[]>();

	@Output()
	getCapOptions = new EventEmitter<string>();

	@Output()
	resetIndirizzoForm = new EventEmitter<void>();

	@Output()
	indirizzoEmitter = new EventEmitter<{ indirizzo: IndirizzoModel, isValid: boolean }>();

	extraSepaForm: FormGroup;

	ibanValidators = [Validators.required, this.extraSepaCountriesValidator(),	ibanValidator(), this.noSpacesValidator()];

	codiceContoValidators = [Validators.required,	this.ValidateNotIban, Validators.maxLength(44)];

	private subscription: Subscription = new Subscription();

	getErrorMessage = getErrorMessage;

	sepaCountries = [{"name":"Austria","code":"AT","iban":"AT493200056563289974"},{"name":"Belgium","code":"BE","iban":"BE65561689528896"},{"name":"Bulgaria","code":"BG","iban":"BG92TTBB94006559266188"},{"name":"Cyprus","code":"CY","iban":"CY52665561416772369457864437"},{"name":"Croatia","code":"HR","iban":"HR5523400098663266246"},{"name":"Denmark","code":"DK","iban":"DK2550515918328528"},{"name":"Estonia","code":"EE","iban":"EE591286653867491786"},{"name":"Finland","code":"FI","iban":"FI8479486911788598"},{"name":"France","code":"FR","iban":"FR8514508000707239488738J21"},{"name":"Germany","code":"DE","iban":"DE14500105174185484177"},{"name":"Greece","code":"GR","iban":"GR9201494491588141549531799"},{"name":"Ireland","code":"IE","iban":"IE29AIBK93115212345678"},{"name":"Italy","code":"IT","iban":"IT77R0300203280648419668253"},{"name":"Latvia","code":"LV","iban":"LV80BANK0000435195001"},{"name":"Lithuania","code":"LT","iban":"LT275168179993645428"},{"name":"Luxembourg","code":"LU","iban":"LU350106814331716425"},{"name":"Malta","code":"MT","iban":"MT54WLCI12377529685589454747835"},{"name":"Netherlands","code":"NL","iban":"NL13INGB6755037397"},{"name":"Poland","code":"PL","iban":"PL06109024023962236263666664"},{"name":"Portugal","code":"PT","iban":"PT26003506516995234369482"},{"name":"Czech Republic","code":"CZ","iban":"CZ1350515343291243261222"},{"name":"Romania","code":"RO","iban":"RO64RZBR2335521926768262"},{"name":"Slovakia","code":"SK","iban":"SK6053419589142643828262"},{"name":"Slovenia","code":"SI","iban":"SI97975426678332786"},{"name":"Spain","code":"ES","iban":"ES7231904977492569944158"},{"name":"Sweden","code":"SE","iban":"SE4949996195749755572136"},{"name":"Hungary","code":"HU","iban":"HU42117730161111101800000000"},{"name":"Norway","code":"NO","iban":"NO9386011117947"},{"name":"Liechtenstein","code":"LI","iban":"LI7008800683146527484"},{"name":"Iceland","code":"IS","iban":"IS140159260076545510730339"},{"name":"Switzerland","code":"CH","iban":"CH4789144623328263139"},{"name":"United Kingdom","code":"GB","iban":"GB09BARC20040416289669"},{"name":"Monaco","code":"MC","iban":"MC2112739000407179846124F08"},{"name":"Andorra","code":"AD","iban":"AD5127638574262995775744"},{"name":"San Marino","code":"SM","iban":"SM86U0322509800000000270100"},{"name":"Holy See (Vatican City State)","code":"VA","iban":"VA59001123000012345678"}];

	delegato: DatiPersonaFisicaModel;

	isDelegatoValid: boolean;

	indirizzo: IndirizzoModel;

	isIndirizzoValid: boolean;

	cap: string[];

	codiceCatastale: string;

	constructor(private modalitaPagamentoService: ModalitaPagamentoService) {
		// this.initExtraSepaForm();
	}

	ngOnInit(): void {
		this.initExtraSepaForm();
		this.subscription.add(
			this.extraSepaForm.controls['codiceContoPresent'].valueChanges.subscribe(
				(codiceContoPresent) => {
					if (codiceContoPresent) {
						this.extraSepaForm.controls['iban'].setValidators([]);
						this.extraSepaForm.controls['iban'].patchValue(null);
						this.extraSepaForm.controls['iban'].updateValueAndValidity();
						this.extraSepaForm.controls['codiceConto'].setValidators(this.codiceContoValidators);
						this.extraSepaForm.controls['codiceConto'].updateValueAndValidity();
					} else {
						this.extraSepaForm.controls['codiceConto'].setValidators([]);
						this.extraSepaForm.controls['codiceConto'].patchValue(null);
						this.extraSepaForm.controls['codiceConto'].updateValueAndValidity();
						this.extraSepaForm.controls['iban'].setValidators(this.ibanValidators);
						this.extraSepaForm.controls['iban'].updateValueAndValidity();
					}
				}
			)
		);

		this.subscription.add(
			this.extraSepaForm.controls['swiftBicPresent'].valueChanges.subscribe(
				(swiftBicPresent) => {
					if (swiftBicPresent) {
						this.extraSepaForm.controls['swift'].setValidators([Validators.required,	Validators.maxLength(11),	Validators.minLength(8)]);
						this.extraSepaForm.controls['swift'].updateValueAndValidity();
						this.extraSepaForm.controls['nazione'].setValidators([]);
						this.extraSepaForm.controls['nazione'].patchValue(null);
						this.extraSepaForm.controls['nazione'].updateValueAndValidity();
						this.extraSepaForm.controls['citta'].setValidators([]);
						this.extraSepaForm.controls['citta'].patchValue(null);
						this.extraSepaForm.controls['citta'].updateValueAndValidity();
						this.extraSepaForm.controls['banca'].setValidators([]);
						this.extraSepaForm.controls['banca'].patchValue(null);
						this.extraSepaForm.controls['banca'].updateValueAndValidity();
						this.extraSepaForm.controls['indirizzo'].setValidators([]);
						this.extraSepaForm.controls['indirizzo'].patchValue(null);
						this.extraSepaForm.controls['indirizzo'].updateValueAndValidity();
						this.extraSepaForm.controls['zipCode'].setValidators([]);
						this.extraSepaForm.controls['zipCode'].patchValue(null);
						this.extraSepaForm.controls['zipCode'].updateValueAndValidity();
						this.extraSepaForm.controls['civico'].setValidators([]);
						this.extraSepaForm.controls['civico'].updateValueAndValidity();
						this.extraSepaForm.controls['civico'].patchValue(null);
					} else {
						this.extraSepaForm.controls['swift'].setValidators([]);
						this.extraSepaForm.controls['swift'].patchValue(null);
						this.extraSepaForm.controls['swift'].updateValueAndValidity();
						this.extraSepaForm.controls['nazione'].setValidators([Validators.required]);
						this.extraSepaForm.controls['nazione'].updateValueAndValidity();
						this.extraSepaForm.controls['citta'].setValidators([Validators.required]);
						this.extraSepaForm.controls['citta'].updateValueAndValidity();
						this.extraSepaForm.controls['banca'].setValidators([Validators.required]);
						this.extraSepaForm.controls['banca'].updateValueAndValidity();
						this.extraSepaForm.controls['indirizzo'].setValidators([Validators.required]);
						this.extraSepaForm.controls['indirizzo'].updateValueAndValidity();
						this.extraSepaForm.controls['zipCode'].setValidators([Validators.required]);
						this.extraSepaForm.controls['zipCode'].updateValueAndValidity();
						this.extraSepaForm.controls['civico'].setValidators([Validators.required]);
						this.extraSepaForm.controls['civico'].updateValueAndValidity();
					}
				}
			)
		);

		this.extraSepaForm.valueChanges.subscribe(() => {
      // if (this.extraSepaForm.valid) {
        const bonificoExtraSepa: BonificoExtraSepaModel = {
					swift: this.extraSepaForm.get('swift').value,
					codiceContoPresent: this.extraSepaForm.get('codiceContoPresent').value,
					codiceConto: this.extraSepaForm.get('codiceConto').value,
					iban: this.extraSepaForm.get('iban').value,
					delegato: this.extraSepaForm.get('existsDelegatoRiscossione').value,
					delegatoRiscossione: this.extraSepaForm.get('existsDelegatoRiscossione').value ? this.delegato : null,
					banca: this.extraSepaForm.get('banca').value,
					filiale: this.extraSepaForm.get('citta').value,
					indirizzo: this.extraSepaForm.get('indirizzo').value,
					swiftBicPresent: this.extraSepaForm.get('swiftBicPresent').value,
					nazione: this.extraSepaForm.get('nazione').value,
					zipCode: this.extraSepaForm.get('zipCode').value,
					codiceProvincia: 'EE',
					civico: this.extraSepaForm.get('civico').value,
					indirizzoDelegato: this.extraSepaForm.get('existsDelegatoRiscossione').value === true ? this.indirizzo : null
				};

				const isFormValid = this.extraSepaForm.valid;
				const isFormDelegatoValid = this.extraSepaForm.get('existsDelegatoRiscossione').value === true ? this.isDelegatoValid && this.isIndirizzoValid : true;
        const isValid = isFormValid && isFormDelegatoValid;

        this.bonificoExtraSepaReady.emit({ bonifico: bonificoExtraSepa, isValid });
       //}
    });
	}

	initExtraSepaForm(): void {
		this.extraSepaForm = new FormGroup({
			existsDelegatoRiscossione: new FormControl(this.bonificoExtraSepa != null ? this.bonificoExtraSepa.delegato : false, [Validators.required]),
			swift: new FormControl(this.bonificoExtraSepa?.swift, [Validators.required,	Validators.maxLength(11),	Validators.minLength(8)]),
			banca: new FormControl(this.bonificoExtraSepa?.banca, [Validators.required]),
			indirizzo: new FormControl(this.bonificoExtraSepa?.indirizzo, [Validators.required]),
			codiceContoPresent: new FormControl(this.bonificoExtraSepa != null ? this.bonificoExtraSepa.codiceContoPresent : false, [Validators.required]),
			codiceConto: new FormControl(this.bonificoExtraSepa?.codiceConto, this.codiceContoValidators),
			iban: new FormControl(this.bonificoExtraSepa?.iban, this.ibanValidators),
			swiftBicPresent: new FormControl(this.bonificoExtraSepa?.swift ? true : false, [Validators.required]),
			nazione: new FormControl(this.bonificoExtraSepa?.nazione, [Validators.required]),
			citta: new FormControl(this.bonificoExtraSepa?.filiale, [Validators.required]),
			zipCode: new FormControl(this.bonificoExtraSepa?.zipCode, [Validators.required]),
			civico: new FormControl(this.bonificoExtraSepa?.civico, [Validators.required]),
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	onValidateExtraSepaPersonaFisica(): void {
		this.validateExtraSepaPersonaFisicaEmitter.emit();
	}

	onExistsDelegatoRiscossioneChange(tipo): void {
		if (!tipo.value) {
			this.isDelegatoValid = true;
			this.resetEstremiPersonaFisicaExtraSepaFormEmitter.emit();
			this.resetIndirizzoForm.emit();
		}
	}

	byCode(n1: NazioneModel, n2: NazioneModel) {
		return n1?.codiceCatastale == n2?.codiceCatastale;
	}

	ValidateNotIban(control: AbstractControl) {
		if (!control.value) {
		  return null;
		}
		const ibanRegex : RegExp = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/;

		if (ibanRegex.test(control.value.toString().trim())) {
		  return { codiceContoSchouldNotBeIban: true };
		}

		return null;
	}

	extraSepaCountriesValidator(): ValidatorFn {
		return (form: AbstractControl) => {
			const iban = form.value;
			if (!iban || iban?.length < 2) {
				return null;
			}

			const countryCode: string = iban.substring(0, 2);
			if (this.sepaCountries.some((element) => element.code === countryCode)) {
				return { ibanSepa: true };
			}

			return null;
		};
	}

	onDelegatoRiscossioneReady(event: { persona: DatiPersonaFisicaModel, isValid: boolean }){
		this.delegato = event.persona;
		this.isDelegatoValid = event.isValid;
		this.personaFisicaEmitter.emit({ persona: event.persona, isValid: event.isValid });
	}

	convertToUppercase(value: string) {
		if(this.extraSepaForm.controls['codiceContoPresent'].value){
			this.extraSepaForm.get('codiceConto').setValue(value.toUpperCase());
		}else{
			this.extraSepaForm.get('iban').setValue(value.toUpperCase());
		}
	}

	noSpacesValidator(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			const hasSpaces = /\s/.test(control.value);
			return hasSpaces ? { spacesIban: true } : null;
		};
	}

	getComuni(siglaProvincia: string): void {
		if (siglaProvincia) {
			this.modalitaPagamentoService.getComuni$(siglaProvincia).pipe(take(1))
				.subscribe(comuni => {
						this.setComuni.emit(comuni);
						const comune = comuni.find(comuneItem => comuneItem.codiceCatastale === this.codiceCatastale);
						this.getCapOptions.emit(comune?.codiceIstat);
				})
		} else {
			this.setComuni.emit([]);
		}
	}

	onIndirizzoReady(event: { indirizzo: IndirizzoModel, isValid: boolean }) {
		this.indirizzo = event.indirizzo;
		this.isIndirizzoValid = event.isValid;
		this.indirizzoEmitter.emit({ indirizzo: event.indirizzo, isValid: event.isValid });
	}

	getCap(codiceCatastale: string): void {
		if (codiceCatastale) {
			this.codiceCatastale = codiceCatastale;
		}
		const comune = this.comuni?.find(comuneItem => comuneItem.codiceCatastale === codiceCatastale);
		this.getCapOptions.emit(comune?.codiceIstat);
	}

}


